import * as React from "react";
const SvgFiRrTrashUndo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16 15.5v2a1 1 0 1 1-2 0v-2c0-1.103-.897-2-2-2h-1.898l1.293 1.293a.999.999 0 1 1-1.414 1.414l-1.613-1.614a2.965 2.965 0 0 1 0-4.187l1.613-1.614a.999.999 0 1 1 1.414 1.414l-1.293 1.293H12c2.206 0 4 1.794 4 4zM23 5a1 1 0 0 1-1 1h-.886l-1.276 13.472A4.98 4.98 0 0 1 14.861 24H9.133a4.98 4.98 0 0 1-4.977-4.521L2.86 6h-.861a1 1 0 1 1 0-2H6.1a5.01 5.01 0 0 1 4.899-4h2a5.01 5.01 0 0 1 4.899 4h4.101A1 1 0 0 1 23 5M8.172 4h7.656A3 3 0 0 0 13 2h-2a3 3 0 0 0-2.828 2m10.934 2H4.87l1.277 13.287A2.99 2.99 0 0 0 9.133 22h5.728a2.987 2.987 0 0 0 2.986-2.717z"
    />
  </svg>
);
export default SvgFiRrTrashUndo;
